interface Props {
  height?: number;
  width: number | string;
  label: string;
}

const ResultGraph = ({
  width = 443,
  height = 267,
  label = "Goal Weight",
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 443 267"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.9652 262V250.678H25.3732V248.59H30.4132V262H27.9652ZM33.209 262V252.208H35.423V254.476L35.171 254.098C35.351 253.39 35.711 252.862 36.251 252.514C36.791 252.166 37.427 251.992 38.159 251.992C38.963 251.992 39.671 252.202 40.283 252.622C40.895 253.042 41.291 253.594 41.471 254.278L40.805 254.332C41.105 253.552 41.555 252.97 42.155 252.586C42.755 252.19 43.445 251.992 44.225 251.992C44.921 251.992 45.539 252.148 46.079 252.46C46.631 252.772 47.063 253.21 47.375 253.774C47.687 254.326 47.843 254.968 47.843 255.7V262H45.485V256.258C45.485 255.826 45.407 255.454 45.251 255.142C45.095 254.83 44.879 254.59 44.603 254.422C44.327 254.242 43.991 254.152 43.595 254.152C43.223 254.152 42.893 254.242 42.605 254.422C42.317 254.59 42.095 254.83 41.939 255.142C41.783 255.454 41.705 255.826 41.705 256.258V262H39.347V256.258C39.347 255.826 39.269 255.454 39.113 255.142C38.957 254.83 38.735 254.59 38.447 254.422C38.171 254.242 37.841 254.152 37.457 254.152C37.085 254.152 36.755 254.242 36.467 254.422C36.179 254.59 35.957 254.83 35.801 255.142C35.645 255.454 35.567 255.826 35.567 256.258V262H33.209ZM54.6259 262.216C53.6659 262.216 52.7899 261.994 51.9979 261.55C51.2179 261.106 50.5939 260.5 50.1259 259.732C49.6699 258.964 49.4419 258.088 49.4419 257.104C49.4419 256.12 49.6699 255.244 50.1259 254.476C50.5939 253.708 51.2179 253.102 51.9979 252.658C52.7779 252.214 53.6539 251.992 54.6259 251.992C55.5859 251.992 56.4559 252.214 57.2359 252.658C58.0159 253.102 58.6339 253.708 59.0899 254.476C59.5579 255.232 59.7919 256.108 59.7919 257.104C59.7919 258.088 59.5579 258.964 59.0899 259.732C58.6219 260.5 57.9979 261.106 57.2179 261.55C56.4379 261.994 55.5739 262.216 54.6259 262.216ZM54.6259 260.056C55.1539 260.056 55.6159 259.93 56.0119 259.678C56.4199 259.426 56.7379 259.078 56.9659 258.634C57.2059 258.178 57.3259 257.668 57.3259 257.104C57.3259 256.528 57.2059 256.024 56.9659 255.592C56.7379 255.148 56.4199 254.8 56.0119 254.548C55.6159 254.284 55.1539 254.152 54.6259 254.152C54.0859 254.152 53.6119 254.284 53.2039 254.548C52.7959 254.8 52.4719 255.148 52.2319 255.592C52.0039 256.024 51.8899 256.528 51.8899 257.104C51.8899 257.668 52.0039 258.178 52.2319 258.634C52.4719 259.078 52.7959 259.426 53.2039 259.678C53.6119 259.93 54.0859 260.056 54.6259 260.056Z"
        fill="white"
      />
      <path
        d="M202.503 262.216C201.591 262.216 200.781 262.024 200.073 261.64C199.377 261.244 198.831 260.716 198.435 260.056C198.039 259.384 197.841 258.622 197.841 257.77C197.841 257.338 197.883 256.906 197.967 256.474C198.063 256.042 198.231 255.58 198.471 255.088C198.723 254.596 199.083 254.05 199.551 253.45L203.295 248.59H206.211L201.657 254.44L201.261 254.008C201.429 253.876 201.603 253.774 201.783 253.702C201.963 253.618 202.143 253.558 202.323 253.522C202.515 253.486 202.713 253.468 202.917 253.468C203.733 253.468 204.459 253.654 205.095 254.026C205.731 254.398 206.229 254.908 206.589 255.556C206.961 256.192 207.147 256.912 207.147 257.716C207.147 258.58 206.949 259.354 206.553 260.038C206.157 260.71 205.605 261.244 204.897 261.64C204.201 262.024 203.403 262.216 202.503 262.216ZM202.503 260.002C202.911 260.002 203.277 259.912 203.601 259.732C203.937 259.54 204.201 259.27 204.393 258.922C204.597 258.574 204.699 258.184 204.699 257.752C204.699 257.296 204.597 256.906 204.393 256.582C204.201 256.246 203.943 255.982 203.619 255.79C203.295 255.598 202.923 255.502 202.503 255.502C202.095 255.502 201.723 255.598 201.387 255.79C201.051 255.982 200.781 256.246 200.577 256.582C200.385 256.906 200.289 257.296 200.289 257.752C200.289 258.184 200.385 258.574 200.577 258.922C200.781 259.27 201.051 259.54 201.387 259.732C201.723 259.912 202.095 260.002 202.503 260.002ZM208.993 262V252.208H211.207V254.476L210.955 254.098C211.135 253.39 211.495 252.862 212.035 252.514C212.575 252.166 213.211 251.992 213.943 251.992C214.747 251.992 215.455 252.202 216.067 252.622C216.679 253.042 217.075 253.594 217.255 254.278L216.589 254.332C216.889 253.552 217.339 252.97 217.939 252.586C218.539 252.19 219.229 251.992 220.009 251.992C220.705 251.992 221.323 252.148 221.863 252.46C222.415 252.772 222.847 253.21 223.159 253.774C223.471 254.326 223.627 254.968 223.627 255.7V262H221.269V256.258C221.269 255.826 221.191 255.454 221.035 255.142C220.879 254.83 220.663 254.59 220.387 254.422C220.111 254.242 219.775 254.152 219.379 254.152C219.007 254.152 218.677 254.242 218.389 254.422C218.101 254.59 217.879 254.83 217.723 255.142C217.567 255.454 217.489 255.826 217.489 256.258V262H215.131V256.258C215.131 255.826 215.053 255.454 214.897 255.142C214.741 254.83 214.519 254.59 214.231 254.422C213.955 254.242 213.625 254.152 213.241 254.152C212.869 254.152 212.539 254.242 212.251 254.422C211.963 254.59 211.741 254.83 211.585 255.142C211.429 255.454 211.351 255.826 211.351 256.258V262H208.993ZM230.41 262.216C229.45 262.216 228.574 261.994 227.782 261.55C227.002 261.106 226.378 260.5 225.91 259.732C225.454 258.964 225.226 258.088 225.226 257.104C225.226 256.12 225.454 255.244 225.91 254.476C226.378 253.708 227.002 253.102 227.782 252.658C228.562 252.214 229.438 251.992 230.41 251.992C231.37 251.992 232.24 252.214 233.02 252.658C233.8 253.102 234.418 253.708 234.874 254.476C235.342 255.232 235.576 256.108 235.576 257.104C235.576 258.088 235.342 258.964 234.874 259.732C234.406 260.5 233.782 261.106 233.002 261.55C232.222 261.994 231.358 262.216 230.41 262.216ZM230.41 260.056C230.938 260.056 231.4 259.93 231.796 259.678C232.204 259.426 232.522 259.078 232.75 258.634C232.99 258.178 233.11 257.668 233.11 257.104C233.11 256.528 232.99 256.024 232.75 255.592C232.522 255.148 232.204 254.8 231.796 254.548C231.4 254.284 230.938 254.152 230.41 254.152C229.87 254.152 229.396 254.284 228.988 254.548C228.58 254.8 228.256 255.148 228.016 255.592C227.788 256.024 227.674 256.528 227.674 257.104C227.674 257.668 227.788 258.178 228.016 258.634C228.256 259.078 228.58 259.426 228.988 259.678C229.396 259.93 229.87 260.056 230.41 260.056Z"
        fill="white"
      />
      <path
        d="M372.595 262V250.678H370.003V248.59H375.043V262H372.595ZM377.569 262V260.146L381.205 256.348C381.925 255.592 382.477 254.992 382.861 254.548C383.257 254.092 383.533 253.702 383.689 253.378C383.845 253.054 383.923 252.724 383.923 252.388C383.923 251.824 383.743 251.38 383.383 251.056C383.035 250.732 382.585 250.57 382.033 250.57C381.457 250.57 380.959 250.738 380.539 251.074C380.119 251.398 379.813 251.878 379.621 252.514L377.479 251.848C377.623 251.14 377.917 250.528 378.361 250.012C378.805 249.484 379.345 249.082 379.981 248.806C380.629 248.518 381.313 248.374 382.033 248.374C382.897 248.374 383.653 248.53 384.301 248.842C384.961 249.154 385.471 249.592 385.831 250.156C386.203 250.72 386.389 251.38 386.389 252.136C386.389 252.616 386.299 253.09 386.119 253.558C385.939 254.026 385.669 254.506 385.309 254.998C384.949 255.478 384.481 256.018 383.905 256.618L380.755 259.93H386.569V262H377.569ZM388.579 262V252.208H390.793V254.476L390.541 254.098C390.721 253.39 391.081 252.862 391.621 252.514C392.161 252.166 392.797 251.992 393.529 251.992C394.333 251.992 395.041 252.202 395.653 252.622C396.265 253.042 396.661 253.594 396.841 254.278L396.175 254.332C396.475 253.552 396.925 252.97 397.525 252.586C398.125 252.19 398.815 251.992 399.595 251.992C400.291 251.992 400.909 252.148 401.449 252.46C402.001 252.772 402.433 253.21 402.745 253.774C403.057 254.326 403.213 254.968 403.213 255.7V262H400.855V256.258C400.855 255.826 400.777 255.454 400.621 255.142C400.465 254.83 400.249 254.59 399.973 254.422C399.697 254.242 399.361 254.152 398.965 254.152C398.593 254.152 398.263 254.242 397.975 254.422C397.687 254.59 397.465 254.83 397.309 255.142C397.153 255.454 397.075 255.826 397.075 256.258V262H394.717V256.258C394.717 255.826 394.639 255.454 394.483 255.142C394.327 254.83 394.105 254.59 393.817 254.422C393.541 254.242 393.211 254.152 392.827 254.152C392.455 254.152 392.125 254.242 391.837 254.422C391.549 254.59 391.327 254.83 391.171 255.142C391.015 255.454 390.937 255.826 390.937 256.258V262H388.579ZM409.996 262.216C409.036 262.216 408.16 261.994 407.368 261.55C406.588 261.106 405.964 260.5 405.496 259.732C405.04 258.964 404.812 258.088 404.812 257.104C404.812 256.12 405.04 255.244 405.496 254.476C405.964 253.708 406.588 253.102 407.368 252.658C408.148 252.214 409.024 251.992 409.996 251.992C410.956 251.992 411.826 252.214 412.606 252.658C413.386 253.102 414.004 253.708 414.46 254.476C414.928 255.232 415.162 256.108 415.162 257.104C415.162 258.088 414.928 258.964 414.46 259.732C413.992 260.5 413.368 261.106 412.588 261.55C411.808 261.994 410.944 262.216 409.996 262.216ZM409.996 260.056C410.524 260.056 410.986 259.93 411.382 259.678C411.79 259.426 412.108 259.078 412.336 258.634C412.576 258.178 412.696 257.668 412.696 257.104C412.696 256.528 412.576 256.024 412.336 255.592C412.108 255.148 411.79 254.8 411.382 254.548C410.986 254.284 410.524 254.152 409.996 254.152C409.456 254.152 408.982 254.284 408.574 254.548C408.166 254.8 407.842 255.148 407.602 255.592C407.374 256.024 407.26 256.528 407.26 257.104C407.26 257.668 407.374 258.178 407.602 258.634C407.842 259.078 408.166 259.426 408.574 259.678C408.982 259.93 409.456 260.056 409.996 260.056Z"
        fill="white"
      />
      <line
        x1="42.5"
        y1="242"
        x2="42.5"
        y2="31"
        stroke="url(#paint0_linear_3367_16341)"
        strokeDasharray="3 3"
      />
      <line
        x1="216.5"
        y1="242"
        x2="216.5"
        y2="136"
        stroke="url(#paint1_linear_3367_16341)"
        strokeDasharray="3 3"
      />
      <line
        x1="391.5"
        y1="241.991"
        x2="392.5"
        y2="188.991"
        stroke="url(#paint2_linear_3367_16341)"
        strokeDasharray="3 3"
      />
      <g filter="url(#filter0_d_3367_16341)">
        <circle cx="42.5" cy="40.5" r="10.5" fill="white" />
      </g>
      <g filter="url(#filter1_d_3367_16341)">
        <circle cx="216.5" cy="130.5" r="10.5" fill="white" />
      </g>
      <g filter="url(#filter2_d_3367_16341)">
        <circle cx="392.5" cy="185.5" r="10.5" fill="white" />
      </g>
      <path
        d="M42.5 40C42.5 40 94.9721 47.0856 136.502 68.0241C172.121 85.9822 216.501 131.535 216.501 131.535C285.439 181.352 307.872 191.937 392.502 186.024"
        stroke="white"
      />
      <rect
        x="339"
        y="121"
        width="104"
        height="40"
        rx="8"
        fill="white"
        fillOpacity="0.9"
      />
      <text
        x={339 + 10}
        y={121 + 26}
        fill="#005765"
        fontSize="16"
        fontFamily="Inter, sans-serif"
        textAnchor="start"
      >
        {label}
      </text>
      <defs>
        <filter
          id="filter0_d_3367_16341"
          x="0"
          y="0"
          width="89"
          height="89"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="10"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_3367_16341"
          />
          <feOffset dx="2" dy="4" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.46 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3367_16341"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3367_16341"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_3367_16341"
          x="174"
          y="90"
          width="89"
          height="89"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="10"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_3367_16341"
          />
          <feOffset dx="2" dy="4" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.46 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3367_16341"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3367_16341"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_3367_16341"
          x="350"
          y="145"
          width="89"
          height="89"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="10"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_3367_16341"
          />
          <feOffset dx="2" dy="4" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.46 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3367_16341"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3367_16341"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3367_16341"
          x1="43.5"
          y1="31"
          x2="43.5"
          y2="242"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3367_16341"
          x1="217.5"
          y1="136"
          x2="217.5"
          y2="242"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3367_16341"
          x1="393.5"
          y1="189.009"
          x2="392.5"
          y2="242.009"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ResultGraph;
